import { defineMessages } from 'react-intl';

const messages = defineMessages({
  modalHeader: {
    id: 'ItemSearchModal.ModalHeader',
    defaultMessage: 'Item Search',
  },
  cancelText: {
    id: 'ItemSearchModal.CancelText',
    defaultMessage: 'Cancel',
  },
  applyText: {
    id: 'ItemSearchModal.ApplyText',
    defaultMessage: 'Apply',
  },
});

export default messages;
